import { createAsyncThunk } from "@reduxjs/toolkit";
import { auth, db } from "../../firebase/config";
import { doc, updateDoc } from "firebase/firestore";

interface IUpdateProfileData {
  userName: string;
  userLocation: string;
  phoneNumber: string;
}

interface IUpdateProfileResponse {
  userName: string;
  userLocation: string;
  phoneNumber: string;
  message: string;
}

interface IRejectValue {
  message: string;
}

export const updateProfile = createAsyncThunk<
  IUpdateProfileResponse,
  IUpdateProfileData,
  { rejectValue: IRejectValue }
>("auth/updateProfile", async (data, thunkAPI) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }

    // Update user document in Firestore
    const userDocRef = doc(db, "users", user.uid);
    await updateDoc(userDocRef, {
      userName: data.userName,
      userLocation: data.userLocation,
      phoneNumber: data.phoneNumber,
      updatedAt: new Date()
    });

    return {
      userName: data.userName,
      userLocation: data.userLocation,
      phoneNumber: data.phoneNumber,
      message: "Profile updated successfully"
    };
  } catch (error) {
    if (error instanceof Error) {
      return thunkAPI.rejectWithValue({
        message: error.message
      });
    }
    return thunkAPI.rejectWithValue({
      message: "Failed to update profile"
    });
  }
});
